"use strict"
var moment = require("moment/min/moment-with-locales.min.js");
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = moment;
